<template>
  <div class="circle-slider">
    <svg ref="_svg" :width="side + 'px'" :height="side + 'px'" :viewBox="'-6 -6 ' + (side+12) + ' ' + (side+12)"
         @touchmove="handleTouchMove"
         @click="handleClick"
         @mousedown="handleMouseDown"
         @mouseup="handleMouseUp">
      <g>
        <circle :stroke-width="cpMainCircleStrokeWidth" :cx="cpCenter" :cy="cpCenter" :r="radius" class="circle" fill="none"/>
        <path :stroke-width="cpPathStrokeWidth" :d="cpPathD" class="progress" fill="none"/>
        <circle :r="cpKnobRadius" :cx="cpPathX" :cy="cpPathY" class="knob" @mouseover="knobMouseOver" @mouseout="knobMouseOut"/>
      </g>
    </svg>
    <p class="text">{{ prefix }}{{ formattedValue }}{{ suffix }}</p>
  </div>
</template>
<script>
import TouchPosition from './touch_position.js';
import CircleSliderState from './circle_slider_state.js';

export default {
  name: 'CircleSliderVKB',
  props: {
    readonly: Boolean,
    startAngleOffset: {
      type: Number,
      required: false,
      default: function () {
        // return Math.PI / 20
        return 0;
      }
    },
    value: {
      type: Number,
      required: false,
      default: 0
    },
    side: {
      type: Number,
      required: false,
      default: 100
    },
    stepSize: {
      type: Number,
      required: false,
      default: 1
    },
    min: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: 100
    },
    knobRadius: {
      type: Number,
      required: false,
      default: null
    },
    knobRadiusRel: {
      type: Number,
      required: false,
      default: 7
    },
    circleWidth: {
      type: Number,
      required: false,
      default: null
    },
    circleWidthRel: {
      type: Number,
      required: false,
      default: 20
    },
    progressWidth: {
      type: Number,
      required: false,
      default: null
    },
    progressWidthRel: {
      type: Number,
      required: false,
      default: 10
    },
    validValues: {
      type: Array,
      required: false,
    },
    prefix: {
      type: String,
      required: false,
      default: '€ '
    },
    suffix: {
      type: String,
      required: false,
      default: ''
    },
    theme: {
      type: String,
      required: false,
      default: ''
    },
    // limitMin: {
    //   type: Number,
    //   required: false,
    //   default: null
    // },
    // limitMax: {
    //   type: Number,
    //   required: false,
    //   default: null
    // }
  },
  data () {
    return {
      steps: null,
      stepsCount: null,
      radius: 0,
      angle: 0,
      currentStepValue: 0,
      mousePressed: false,
      circleSliderState: null,
      mousemoveTicks: 0
    };
  },
  computed: {
    // cpStartAngleOffset () {
    //   if (!this.minStepLimit) {
    //     return 0
    //   }
    // },
    cpCenter () {
      return this.side / 2;
    },
    cpAngle () {
      return this.angle + Math.PI / 2;
    },
    cpMainCircleStrokeWidth () {
      return 3; //this.circleWidth || (this.side / 2) / this.circleWidthRel;
    },
    cpPathDirection () {
      return (this.cpAngle < 3 * Math.PI / 2) ? 0 : 1;
    },
    cpPathX () {
      return this.cpCenter + this.radius * Math.cos(this.cpAngle + Math.PI);
    },
    cpPathY () {
      return this.cpCenter + this.radius * Math.sin(this.cpAngle + Math.PI);
    },
    cpPathStrokeWidth () {
      return 6; //this.progressWidth || (this.side / 2) / this.progressWidthRel;
    },
    cpKnobRadius () {
      return 12;
      //return this.knobRadius || (this.side / 2) / this.knobRadiusRel;
    },
    cpPathD () {
      const parts = [];
      parts.push('M' + this.cpCenter);
      parts.push(this.cpCenter - this.radius);
      parts.push('A');
      parts.push(this.radius);
      parts.push(this.radius);
      parts.push(0);
      parts.push(this.cpPathDirection);
      parts.push(1);
      parts.push(this.cpPathX);
      parts.push(this.cpPathY);
      return parts.join(' ');
    },
    formattedValue() {
      return (this.roundToValidValue(this.currentStepValue).toFixed(0)+'.').replace(/(\d)(?=(\d{3})+\.)/g, '$1.').slice(0, -1);
    }
  },
  created () {
    this.stepsCount = 1 + (this.max - this.min) / this.stepSize;
    this.steps = Array.from({
      length: this.stepsCount
    }, (_, i) => this.min + i * this.stepSize);

    this.circleSliderState = new CircleSliderState(this.steps, this.startAngleOffset, this.value);
    this.angle = this.circleSliderState.angleValue;
    this.currentStepValue = this.circleSliderState.currentStep;

    const maxCurveWidth = Math.max(this.cpMainCircleStrokeWidth, this.cpPathStrokeWidth);
    this.radius = (this.side / 2) - Math.max(maxCurveWidth, this.cpKnobRadius * 2) / 2;
    this.updateFromPropValue(this.value);
  },
  mounted () {
    this.touchPosition = new TouchPosition(this.$refs._svg, this.radius, this.radius / 2);
  },
  methods: {
    knobMouseOver(evt){
      let raidus = this.cpKnobRadius * 1.5;
      evt.target.setAttribute('r', raidus);
    },
    knobMouseOut(evt){
      let raidus = this.cpKnobRadius;
      evt.target.setAttribute('r', raidus);
    },
    roundToValidValue(x) {
      if (this.max && x > this.max) {
        return this.max;
      }
      if (!this.validValues) {
        return x;
      }
      const errors = this.validValues.map(v => Math.abs(v - x));
      let min = errors[0];
      let minIndex = 0;

      for (const i in errors) {
        const e = errors[i];
        if (e < min) {
          min = e;
          minIndex = i;
        }
      }
      return this.validValues[minIndex];
    },
    /*
     */
    fitToStep (val) {
      return Math.round(val / this.stepSize) * this.stepSize;
    },

    /*
     */
    handleClick (e) {
      if (this.readonly) {
        return;
      }
      this.touchPosition.setNewPosition(e);
      if (this.touchPosition.isTouchWithinSliderRange) {
        const newAngle = this.touchPosition.sliderAngle;
        this.animateSlider(this.angle, newAngle);
      }
    },

    /*
     */
    handleMouseDown (e) {
      e.preventDefault();
      if (this.readonly) {
        return;
      }
      this.mousePressed = true;
      window.addEventListener('mousemove', this.handleWindowMouseMove);
      window.addEventListener('mouseup', this.handleMouseUp);
    },

    /*
     */
    handleMouseUp (e) {
      e.preventDefault();
      if (this.readonly) {
        return;
      }
      this.mousePressed = false;
      window.removeEventListener('mousemove', this.handleWindowMouseMove);
      window.removeEventListener('mouseup', this.handleMouseUp);
      this.mousemoveTicks = 0;
    },

    /*
     */
    handleWindowMouseMove (e) {
      e.preventDefault();
      if (this.readonly) {
        return;
      }
      if (this.mousemoveTicks < 5) {
        this.mousemoveTicks++;
        return;
      }

      this.touchPosition.setNewPosition(e);
      this.updateSlider();
    },

    /*
     */
    handleTouchMove (e) {
      if (this.readonly) {
        return;
      }
      this.$emit('touchmove');
      // Do nothing if two or more fingers used
      if (e.targetTouches.length > 1 || e.changedTouches.length > 1 || e.touches.length > 1) {
        return true;
      }

      const lastTouch = e.targetTouches.item(e.targetTouches.length - 1);
      this.touchPosition.setNewPosition(lastTouch);

      if (this.touchPosition.isTouchWithinSliderRange) {
        e.preventDefault();
        this.updateSlider();
      }
    },

    /*
     */
    updateAngle (angle) {
      this.circleSliderState.updateCurrentStepFromAngle(angle);
      this.angle = this.circleSliderState.angleValue;
      this.currentStepValue = this.roundToValidValue(this.circleSliderState.currentStep);

      this.$emit('input', this.currentStepValue);
    },

    /*
     */
    updateFromPropValue (value) {
      const stepValue = this.fitToStep(value);
      this.circleSliderState.updateCurrentStepFromValue(stepValue);

      this.angle = this.circleSliderState.angleValue;
      this.currentStepValue = this.roundToValidValue(stepValue);
      this.$emit('input', this.currentStepValue);
    },

    /*
     */
    updateSlider () {
      const angle = this.touchPosition.sliderAngle;
      if (Math.abs(angle - this.angle) < 2 * Math.PI) {
        this.updateAngle(angle);
      }
    },

    /*
     */
    animateSlider (startAngle, endAngle) {
      const direction = startAngle < endAngle ? 1 : -1;
      const curveAngleMovementUnit = direction * this.circleSliderState.angleUnit * 2;

      const animate = () => {
        if (Math.abs(endAngle - startAngle) < Math.abs(2 * curveAngleMovementUnit)) {
          this.updateAngle(endAngle);
        } else {
          const newAngle = startAngle + curveAngleMovementUnit;
          this.updateAngle(newAngle);
          // this.animateSlider(newAngle, endAngle);
        }
      };

      window.requestAnimationFrame(animate);
    }
  },
  watch: {
    value (val) {
      this.updateFromPropValue(val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/thirdparty/CircleSlider/CircleSliderVKB.vue